import { reactive } from "vue";

let toastCount = 0;

const state = reactive({
    toasts: [],
    expanded: false,
});

const MAX_TOASTS = 3;

function addToast(props) {
    const id = ++toastCount;
    state.toasts.push({
        id,
        message: props.message,
        type: props.type || "default",
        duration: props.duration !== undefined ? props.duration : 4000,
        pauseOnHover: props.pauseOnHover !== undefined ? props.pauseOnHover : true,
        onClose: props.onClose,
        height: 0,
    });

    // Evict oldest toast beyond the limit
    if (state.toasts.length > MAX_TOASTS) {
        const oldest = state.toasts[0];
        if (oldest.onClose) oldest.onClose();
        removeToast(oldest.id);
    }

    return id;
}

function removeToast(id) {
    const index = state.toasts.findIndex((t) => t.id === id);
    if (index !== -1) {
        state.toasts.splice(index, 1);
    }
    if (state.toasts.length <= 1) {
        state.expanded = false;
    }
}

function updateHeight(id, height) {
    const toast = state.toasts.find((t) => t.id === id);
    if (toast) {
        toast.height = height;
    }
}

function clearAll() {
    state.toasts.splice(0);
    state.expanded = false;
}

function setExpanded(value) {
    state.expanded = value;
}

function getState() {
    return state;
}

export { getState, addToast, removeToast, updateHeight, clearAll, setExpanded };
